/**
 * Wycena konfiguracji przez REST API sklepu.
 *
 * Cała konfiguracja wyceniana jest jednym żądaniem — identyczne litery są
 * zliczane przez wszystkie linie naraz, spacje nie liczą się do liczby znaków,
 * VAT i rabat użytkownika nakłada serwer. Odpowiedź (items / lines / totals)
 * jest zapisywana w konfiguracji 1:1 i trafia do panelu zamówień jako
 * „Wycena per symbol".
 */
class PriceService {
    constructor() {
        this.baseURL = process.env.REACT_APP_WC_SITE_URL;
    }

    /**
     * Token JWT zalogowanego użytkownika — dzięki niemu serwer nałoży
     * rabat przypisany do konta (pole „rabat" w profilu).
     */
    authHeaders() {
        try {
            const user = JSON.parse(sessionStorage.getItem('user'));
            return user?.token ? { Authorization: 'Bearer ' + user.token } : {};
        } catch (e) {
            return {};
        }
    }

    /**
     * @param {Object} payload - {
     *   lines: [{text, sizeErpId}], fontErpId, mountingErpId, materialErpId, typeErpId, colorErpId
     * }
     * @param {AbortSignal} [signal]
     * @returns {Promise<Object>} odpowiedź endpointu (version, vatRate, discount, items, lines, totals)
     */
    async getConfigurationPrice(payload, signal) {
        const response = await fetch(
            `${this.baseURL}/wp-json/rodlew_app/v1/letter-configuration-price`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...this.authHeaders(),
                },
                body: JSON.stringify(payload),
                signal,
            }
        );

        if (!response.ok) {
            throw new Error(`Price request failed: HTTP ${response.status}`);
        }

        return await response.json();
    }
}

const priceService = new PriceService();
export default priceService;
